"use client";
import React from "react";
import styles from "./ModalKycGuide.module.less";
import { Modal, Button } from "antd";
import { i18nUtil } from "@aspen/libs/index";
import { withRouter } from "next/router";
import type { IInjectProps } from "@aspen/model/index";
import type { TCoverType } from "@adgm/cross-models";

interface IProps extends IInjectProps {
  visible: boolean;
  noClose: boolean;
  handleCancel: () => void;
  handleConfirm: () => void;
  // 传参是否展示跳转profile页面的按钮，不传则默认展示
  showToProfileBtn: boolean;
  coverType?: TCoverType;
}

class ModalKycGuide extends React.PureComponent<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  render(): React.ReactNode {
    const intl = i18nUtil.t();
    const { showToProfileBtn = true, coverType, handleConfirm } = this.props;

    // 根据覆盖类型构建弹窗样式类名：view模式支持背景交互
    const modalWrapClassName = [
      styles.modal,
      coverType === "view" ? styles.backgroundInteraction : "",
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <>
        <Modal
          wrapClassName={modalWrapClassName}
          title={intl["home.kyc.title"]}
          open={this.props.visible}
          centered
          footer={null}
          destroyOnClose
          width={480}
          maskClosable={!this.props.noClose}
          closable={!this.props.noClose}
          maskStyle={{
            pointerEvents: "none",
            backgroundColor: coverType === "view" ? "transparent" : "rgba(0, 0, 0, 0.45)",
          }}
          onCancel={() => this.props.handleCancel()}>
          <div className={styles.actions}>
            {/* 不区分具体状态，统一文案和交互 */}
            <p className={styles.content}>{intl["home.kyc.content"]}</p>
            <Button type="primary" onClick={handleConfirm}>
              {showToProfileBtn ? intl["button.ok"] : intl["home.kyc.action"]}
            </Button>
          </div>
        </Modal>
      </>
    );
  }
}

export default withRouter(ModalKycGuide);
